import React from 'react';
import PropTypes from 'prop-types';
import CaretChevron from 'assets/images/psp/PSPLinks/CaretChevron.svg';
import { Paragraph, Image, Link } from 'components/atoms';

import './PSPLinksCard.scss';

const PSPLinksCard = ({ item }) => {
	if (!item) return null;
	const { url, image, title, description } = item;
	return (
		<Link href={url}>
			<div className="psp-links-card">
				<div className="psp-links-card__image-container">
					<Image
						src={image}
						alt={title}
						className="psp-links-card__image"
					/>
				</div>
				<div className="psp-links-card__description">
					<Paragraph className="psp-links-card__card-title">
						{title}
					</Paragraph>
					<Paragraph className="psp-links-card__card-description">
						{description}
					</Paragraph>
				</div>
				<Image
					src={CaretChevron}
					alt={title}
					className="psp-links-card__icon"
				/>
			</div>
		</Link>
	);
};

PSPLinksCard.propTypes = {
	item: PropTypes.shape({
		url: PropTypes.string,
		title: PropTypes.string.isRequired,
		description: PropTypes.string,
		image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}).isRequired,
};

export default PSPLinksCard;
